import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { db } from '../../services/db';
import Button from '../../components/common/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../components/common/SafeIcon';

const ResourcesEditor = () => {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    db.getResourcesContent().then(setItems);
  }, []);

  const handleChange = (index, field, value) => {
    setItems((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await db.updateResourcesContent(items);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-4xl space-y-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Resources</h2>
          {items.length === 0 ? (
            <p className="text-gray-500">Loading...</p>
          ) : (
            <div className="space-y-4">
              {items.map((item, idx) => (
                <div key={item.id != null ? item.id : idx} className="p-4 border border-gray-200 rounded-lg space-y-2">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <input
                      type="text"
                      placeholder="Title (ES)"
                      value={item.titleEs || ''}
                      onChange={(e) => handleChange(idx, 'titleEs', e.target.value)}
                      className="px-3 py-2 border rounded-lg"
                    />
                    <input
                      type="text"
                      placeholder="Title (EN)"
                      value={item.titleEn || ''}
                      onChange={(e) => handleChange(idx, 'titleEn', e.target.value)}
                      className="px-3 py-2 border rounded-lg"
                    />
                    <input
                      type="text"
                      placeholder="Description (ES)"
                      value={item.descEs || ''}
                      onChange={(e) => handleChange(idx, 'descEs', e.target.value)}
                      className="px-3 py-2 border rounded-lg"
                    />
                    <input
                      type="text"
                      placeholder="Description (EN)"
                      value={item.descEn || ''}
                      onChange={(e) => handleChange(idx, 'descEn', e.target.value)}
                      className="px-3 py-2 border rounded-lg"
                    />
                  </div>
                </div>
              ))}
              <div className="flex items-center gap-4 pt-4 border-t">
                <Button onClick={handleSave} disabled={saving}>
                  {saving ? 'Saving...' : 'Save Resources'}
                </Button>
                {success && (
                  <span className="flex items-center gap-2 text-green-600 text-sm">
                    <SafeIcon icon={FiIcons.FiCheck} /> Saved
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default ResourcesEditor;
